/* import __COLOCATED_TEMPLATE__ from './company-team-pending-invite.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { showModal } from 'sh-www/utils/modal-controls';
import { dropTask } from 'ember-concurrency';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-company-team-pending-invite';

class CompanyTeamPendingInvite extends Component {
  @service('state-managers/application') applicationStateManager;
  @service('commands/company-commands') companyCommandService;
  @service('commands/user-commands') userCommandService;
  @service('error-tracker') errorTracker;
  @service media;
  @service session;

  get classNames() {
    return clsx(
      CLASS_NAME,
      this.args.class,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get _menuDropdownOptions() {
    const menuOptions = [];

    if (this.session.currentUser.isCompanyAdmin || this.session.currentUser.isAdmin) {
      menuOptions.push({
        title: 'Resend',
        onClick: () => this.resendInviteTask.perform(this.args.invite),
      });

      menuOptions.push({
        title: 'Cancel',
        onClick: () => this.onCancelInvite(this.args.invite),
      });
    }

    return menuOptions;
  }

  /**
   * Cancels an invite
   *
   * @param {Invite} invite
   * @return {Ember.RSVP.Promise}
   */
   @dropTask
   *cancelInviteTask(invite) {
    try {
      yield this.companyCommandService.cancelInvite(invite);
      this.args.removeInvite(invite.id);
      this.applicationStateManager.addToast('Invite canceled');
    } catch (e) {
      this.applicationStateManager.addToast(`There was an error cancelling invite.`);
      this.errorTracker.error(`an error occurred while trying to cancel invite -- id: ${invite.id}`, this, e);
    }
  }

  /**
   * Resends an invite
   *
   * @param {Invite} invite
   * @return {Ember.RSVP.Promise}
   */
   @dropTask
   *resendInviteTask(invite) {
    try {
      yield this.companyCommandService.resendInvite(invite);
      this.applicationStateManager.addToast('Invite resent');
    } catch (e) {
      this.applicationStateManager.addToast(`There was an error resending invite.`);
      this.errorTracker.error(`an error occurred while trying to resend invite -- id: ${invite.id}`, this, e);
    }
  }

  @action
  onCancelInvite(invite) {
    showModal(this, 'confirmation', {
      isShowCancelButton: true,
      titleText: 'Are you sure?',
      bodyText: `You are about to delete this invite for person with email "${invite.email}". Do you wish to continue?`,
      confirmAction: () => {
        this.cancelInviteTask.perform(invite);
      },
    });
  }
}

export default CompanyTeamPendingInvite;
